import { api } from "@/api/client";
import type { SimNao } from "./formApi";

const BASE_PATH = "instituicao/ConfiguracaoInstituicao";

// O backend expõe a entity direto (sem DTO). Os campos de auditoria
// (sequencia, situacaoRegistro, datas...) voltam no GET e são preenchidos de
// novo pelo saveOrUpdate — o painel só edita as flags e devolve o resto como veio.
export interface ConfiguracaoInstituicao {
  id?: number;
  idInstituicao?: number;
  seCalcularDisponibilidadeEstoque?: SimNao | null;
  seCalcularDisponibilidadeVencimentoFichaAtual?: SimNao | null;
  seBuscarDadosEvolucaoAnterior?: SimNao | null;
  seLiberarSncr?: SimNao | null;
  [campo: string]: unknown;
}

// Instituição sem config ainda: o backend pode devolver corpo vazio.
export async function getConfiguracaoInstituicao(idInstituicao: number): Promise<ConfiguracaoInstituicao> {
  const { data } = await api.get<ConfiguracaoInstituicao | "">(`${BASE_PATH}/Instituicao/${idInstituicao}`);
  return data || {};
}

export async function saveConfiguracaoInstituicao(idInstituicao: number, config: ConfiguracaoInstituicao): Promise<void> {
  // `instituicao` é a associação read-only da entity; a FK é idInstituicao.
  const { instituicao: _instituicao, ...payload } = config;
  await api.post(BASE_PATH, { ...payload, idInstituicao });
}
